import React, { createContext, useContext, useEffect, useState } from "react";

const WebpSupportContext = createContext(false);

export const WebpSupportProvider = ({ children }) => {
  const [webpSupported, setWebpSupported] = useState(false);

  useEffect(() => {
    // Check for WebP support using canvas
    let isSupported = false;
    try {
      const canvas =
        typeof document !== "undefined"
          ? document.createElement("canvas")
          : null;
      if (canvas && canvas.getContext && canvas.toDataURL) {
        isSupported =
          canvas.toDataURL("image/webp").indexOf("data:image/webp") === 0;
      }
    } catch (e) {
      isSupported = false;
    }
    setWebpSupported(isSupported);
  }, []);

  return (
    <WebpSupportContext.Provider value={webpSupported}>
      {children}
    </WebpSupportContext.Provider>
  );
};

export const useWebpSupport = () => useContext(WebpSupportContext);
